import { render, staticRenderFns } from "./addedit_diag.vue?vue&type=template&id=3e96440e&scoped=true&"
import script from "./addedit_diag.vue?vue&type=script&lang=js&"
export * from "./addedit_diag.vue?vue&type=script&lang=js&"
import style0 from "./addedit_diag.vue?vue&type=style&index=0&id=3e96440e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e96440e",
  null
  
)

export default component.exports